import { breakpoints } from '../utils/breakpoints';
import { STATE } from '../constants/stateClasses';

const selectors = {
  slider: '.js-text-slider',
  btn: '.js-text-slider-btn',
  svgCircle: '.js-svg-circle circle',
  content: '.js-text-slider-content',
};

const CSSVars = {
  contentHeight: '--content-height',
};

const isMobile = window.innerWidth < breakpoints.tablet;

const handleBtnClick = ({ e, index, activeBtn, btns, contents }) => {
  const { currentTarget: target } = e;
  const { index: activeIndex } = activeBtn;

  if (!isMobile && activeIndex === index) return;

  if (activeIndex !== index) {
    btns[activeIndex]?.classList.remove(STATE.active);
  }

  target.classList.toggle(STATE.active);

  activeBtn.index = index;

  if (!isMobile) return;

  const activeContent = contents[index];

  activeContent.style.setProperty(
    CSSVars.contentHeight,
    `${activeContent.scrollHeight}px`
  );
};

const setContentHeights = (slider) => {
  const contents = slider.querySelectorAll(selectors.content);

  if (contents.length === 0) return;

  contents.forEach((content) => {
    content.style.setProperty(
      CSSVars.contentHeight,
      `${content.scrollHeight}px`
    );
  });

  return contents;
};

const changeSlide = ({ btns, activeBtn }) => {
  const { index: activeIndex } = activeBtn;

  const isLastSlide = activeIndex === btns.length - 1;

  btns[activeIndex]?.classList.remove(STATE.active);

  if (isLastSlide) {
    activeBtn.index = 0;
  } else {
    activeBtn.index = activeIndex + 1;
  }

  btns[activeBtn.index]?.classList.add(STATE.active);
};

const handleTextSliderDesktop = ({ btns, activeBtn }) => {
  btns.forEach((btn, index) => {
    const circleSVG = btn.querySelector(selectors.svgCircle);

    circleSVG?.addEventListener('animationend', () => {
      changeSlide({ btns, activeBtn });
    });

    btn.addEventListener('click', (e) => {
      handleBtnClick({ e, index, activeBtn, btns });
    });
  });
};

const handleTextSliderMobile = ({ btns, activeBtn, slider }) => {
  const contents = setContentHeights(slider);

  btns.forEach((btn, index) => {
    btn.addEventListener('click', (e) => {
      handleBtnClick({ e, index, activeBtn, btns, contents });
    });
  });
};

const handleTextSlider = () => {
  const sliders = document.querySelectorAll(selectors.slider);

  if (sliders.length === 0) return;

  sliders.forEach((slider) => {
    const activeBtn = {
      index: 0,
    };
    const btns = slider.querySelectorAll(selectors.btn);

    if (btns.length === 0) return;

    if (isMobile) {
      // Mobile handler
      handleTextSliderMobile({ btns, activeBtn, slider });
    } else {
      // Desktop handler
      handleTextSliderDesktop({ btns, activeBtn });
    }
  });
};
export default handleTextSlider;
